export { default } from './FirstLikeModal';
export type { FirstLikeModalProps } from './FirstLikeModal';
